import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative overflow-hidden pt-16 pb-20 md:pt-24 md:pb-28">
      {/* Background gradient */}
      <div className="absolute inset-0 -z-10" aria-hidden="true">
        <div className="absolute inset-0 bg-gradient-to-b from-lavender-50/80 via-white to-white" />
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-lavender-100/40 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-mint-100/30 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-lavender-100 text-lavender-700 text-sm font-medium mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-lavender-500 animate-pulse" aria-hidden="true" />
          14-day free trial on all plans
        </div>

        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-gray-900 mb-6 leading-tight">
          The operating system for{' '}
          <span className="bg-gradient-to-r from-lavender-600 to-mint-600 bg-clip-text text-transparent">
            print-on-demand
          </span>
        </h1>

        <p className="text-lg md:text-xl text-gray-500 max-w-2xl mx-auto leading-relaxed mb-10">
          Automate your Etsy and Shopify print business. Generate mockups, build gang sheets, manage orders, and run
          your own branded storefront — all from one dashboard.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => navigate('/login?tab=register')}
            className="inline-flex items-center gap-2 px-8 py-3.5 text-base font-semibold text-white bg-gradient-to-r from-lavender-500 to-lavender-600 rounded-xl hover:from-lavender-600 hover:to-lavender-700 shadow-lg shadow-lavender-200/50 hover:shadow-xl transition-all"
          >
            Start Free Trial
            <ArrowRightIcon className="w-4 h-4" aria-hidden="true" />
          </button>
          <a
            href="#pricing"
            className="inline-flex items-center gap-2 px-8 py-3.5 text-base font-semibold text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 hover:border-gray-300 transition-all"
          >
            View Pricing
          </a>
        </div>

        <p className="mt-6 text-sm text-gray-400">No credit card required</p>
      </div>
    </section>
  );
};

export default HeroSection;
